package org.matthewo.api

import kotlinx.serialization.Serializable

@Serializable
data class Search(
    val entries: List<SearchEntry>,
    val activeEvents: List<ActiveEvent>,
) {
    // start is the event's first day as an ISO date (yyyy-MM-dd) in the server's time zone, the same day the server
    // uses to decide the event is active; matchesSoon is whether matches will be played at it soon
    @Serializable
    data class ActiveEvent(val event: SearchEntry.Event, val start: String, val type: Type, val stage: Stage, val matchesSoon: Boolean) {
        enum class Type(val title: String, val abbreviation: String) {
            QUALIFIER("Qualifier", "QUAL"),
            LEAGUE_MEET("League Meet", "MEET"),
            LEAGUE_TOURNAMENT("League Tournament", "LT"),
            CHAMPIONSHIP("Championship", "CMP"),
            WORLD_CHAMPIONSHIP("World Championship", "WORLDS"),
            OFF_SEASON("Off-season", "OFF"),
            OTHER("Scrimmage", "SCRIM"),
        }

        // in the order an event goes through them; league meets go from quals straight to complete
        enum class Stage(val title: String, val abbreviation: String) {
            NOT_STARTED("No Results", "—"),
            SCHEDULED("Qualification Rounds Scheduled", "SCHEDULE"),
            QUALS("Qualification Matches", "QUALS"),
            ALLIANCE_SELECTION("Alliance Selection", "ALLIANCE"),
            PLAYOFFS("Playoff Matches", "PLAYOFFS"),
            AWARDS("Awards Ceremony", "AWARDS"),
            COMPLETE("Complete", "COMPLETE"),
        }
    }
}

@Serializable
sealed class SearchEntry {

    @Serializable
    data class Team(val number: Int, val name: String) : SearchEntry()

    @Serializable
    data class Event(val year: Int, val code: String, val region: String?, val name: String) : SearchEntry()
}
